import type { ProductCard } from "../centra/formatters";

type DepictProductIdResult = undefined | Pick<ProductCard, "depictProductId">;

export const DPC_ID_PARAM = "dpc-id";

export const getProductCardProps = ({
	productId,
	listingId,
	searchResultId,
}: { productId?: string; listingId?: string; searchResultId?: string }) => {
	return {
		"data-product-listing-result-id": listingId,
		"data-search-result-id": searchResultId,
		"data-product-id": productId,
	};
};

export const dpc = {
	getProductCardProps,
};
